// reducer/AuthReducer.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  loginResponse: null,
  signupResponse: null,
  error: null,
  designations: [],
  userData: null,
};

const AuthReducer = createSlice({
  name: "Auth",
  initialState,
  reducers: {
    // LOGIN
    loginRequest: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.isLoading = false;
      state.loginResponse = action.payload;
      state.error = null;
      localStorage.setItem("auth", JSON.stringify(action.payload));
    },
    loginFailure: (state, action) => {
      state.isLoading = false;
      state.loginResponse = null;
      state.error = action.payload;
    },

    // SIGNUP
    signupRequest: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    signupSuccess: (state, action) => {
      state.isLoading = false;
      state.signupResponse = action.payload;
      state.error = null;
    },
    signupFailure: (state, action) => {
      state.isLoading = false;
      state.signupResponse = null;
      state.error = action.payload;
    },

    // LOGOUT
    logoutRequest: (state, action) => {
      state.isLoading = true; // saga will handle API + cleanup
      state.error = null;
    },
    logoutSuccess: (state) => {
      state.isLoading = false;
      state.loginResponse = null;
      state.signupResponse = null;
      state.userData = null;
      state.error = null;
      state.designations = [];
      localStorage.removeItem("auth");
    },
    logoutFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    // ERROR CLEAR
    clearError: (state) => {
      state.error = null;
    },

    // DESIGNATIONS
    getDesignationsRequest: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    getDesignationsSuccess: (state, action) => {
      state.isLoading = false;
      state.designations = action.payload;
    },
    getDesignationsFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    // USER DETAILS
    getUserDetailsRequest: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    getUserDetailsSuccess: (state, action) => {
      state.isLoading = false;
      state.userData = action.payload;
    },
    getUserDetailsFailure: (state, action) => {
      state.isLoading = false;
      state.userData = null;
      state.error = action.payload;
    },
  },
});

export const {
  loginRequest,
  loginSuccess,
  loginFailure,
  signupRequest,
  signupSuccess,
  signupFailure,
  logoutRequest,
  logoutSuccess,
  logoutFailure,
  clearError,
  getDesignationsRequest,
  getDesignationsSuccess,
  getDesignationsFailure,
  getUserDetailsRequest,
  getUserDetailsSuccess,
  getUserDetailsFailure,
} = AuthReducer.actions;

export default AuthReducer.reducer;
